export const environment = {
  production: true,
  siteUrl: 'https://loja.estudeivendi.com.br',
  apiUrl: 'https://southamerica-east1-estudei-vendi.cloudfunctions.net/api',
  onesignal_app_id: '8a12a5c8-cd94-4697-a6c4-b1ad710b3b4b',
  pagarmePublicKey: 'pk_PaA0mBnIz2iDL5YD',
  firebase: {
    projectId: 'estudei-vendi',
    appId: '1:26853260788:web:5ba13b237cf03059e00da1',
    apiKey: 'AIzaSyAilgtwTMpLaT-OdKLd-5RfKkUj_d5w2p8',
    storageBucket: 'estudei-vendi.appspot.com',
    locationId: 'southamerica-east1',
    authDomain: 'estudei-vendi.firebaseapp.com',
    messagingSenderId: '26853260788',
    measurementId: 'G-D1453KN0KM',
  },
};
